import './register-modal';

if (document.querySelector('profile-button')) {
  import(/* webpackChunkName: "profile-button" */ './profile-button');
}

if (document.querySelector('favorite-button')) {
  import(/* webpackChunkName: "favorite-button" */ './favorite-button');
}

if (document.querySelector('unfavorite-button')) {
  import(/* webpackChunkName: "unfavorite-button" */ './unfavorite-button');
}

if (document.querySelector('register-form-controller')) {
  import(/* webpackChunkName: "register-form-controller" */ './register-form-controller');
}

if (document.querySelector('edit-profile-form-controller')) {
  import(/* webpackChunkName: "edit-profile-form-controller" */ './edit-profile-form-controller');
}

if (document.querySelector('delete-account-button')) {
  import(/* webpackChunkName: "delete-account-button" */ './delete-account-button');
}

if (document.querySelector('login-error-message')) {
  import(/* webpackChunkName: "login-error-message" */ './login-error-message');
}

if (document.querySelector('form.potential-login-email-form')) {
  import(/* webpackChunkName: "potential-login-email-form" */ './potential-login-email-form')
    .then((module) => module.default());
}

if (document.querySelector('sg-a-context')) {
  import(/* webpackChunkName: "sg-a-context" */ './auth-context');
}

if (document.querySelector('notification-count-badge')) {
  import(/* webpackChunkName: "notification-count-badge" */ './notification-count-badge');
}